import React from 'react';
import { DateRange, DayPicker } from 'react-day-picker';
import { format } from 'date-fns/format';
import 'react-day-picker/style.css';
import './datetimepicker.css';

interface DateTimePickerProps {
    startDate: Date;
    endDate: Date;
    startChange: (date: Date | null) => void;
    endChange: (date: Date | null) => void;
}

interface State {
    open: boolean;
}

export class DateTimePicker extends React.Component<DateTimePickerProps, State> {
    private containerRef = React.createRef<HTMLDivElement>();

    constructor(props: DateTimePickerProps) {
        super(props);
        this.state = {
            open: false
        };
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleDaySelect = this.handleDaySelect.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event: MouseEvent) {
        if (this.containerRef.current && !this.containerRef.current.contains(event.target as Node)) {
            this.setState({ open: false });
        }
    }

    handleToggle() {
        this.setState(prev => ({ open: !prev.open, selecting: 'start' }));
    }

    handleDaySelect(date: DateRange | undefined) {
        if (!date) return;

        this.props.startChange(date!.from ?? null);
        this.props.endChange(date!.to ?? null);
        
        
    }

    formatDate(date: Date): string {
        return format(date, "do 'of' MMMM, yyyy");
    }

    render() {
        const { startDate, endDate } = this.props;
        const { open } = this.state;

        const selectedRange: DateRange = {
            from: startDate || undefined,
            to: endDate || undefined
        };

        return (
            <div className="date-selector" ref={this.containerRef}>
                <div className="date-range-display" onClick={this.handleToggle}>
                    <span className="date-range-text">
                        {this.formatDate(startDate)} - {this.formatDate(endDate)}
                    </span>
                    <span className="dropdown-arrow">{open ? '\u25B2' : '\u25BC'}</span>
                </div>
                {open && (
                    <div className="date-dropdown">
                        <DayPicker
                            mode="range"
                            selected={selectedRange}
                            onSelect={this.handleDaySelect}
                        />
                    </div>
                )}
            </div>
        );
    }
}
